import React, { useEffect, useState } from 'react';
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons"
import { config } from '../../../config';
import axiosApi from '../../../core/interceptor/interceptor';
import WarningDialogue from '../../WarningDialogue';
import ViewUserDetails from './ViewUserDetails';
import SimpleBarReact from 'simplebar-react';

export default function ModalContentUser(props) {
    const [data, setData] = useState(props.data);
    let shirtSize = 'N/A';
    const [checkbox, setCheckbox] = useState(!!data.account_locked);
    const [accountStatus, setAccountStatus] = useState(false);
    const [openWarningPopup, setOpenWarningPopup] = useState(false);
    const [popupContent, setPopupContent] = useState(false);
    const [leagueInfo, setLeagueInfo] = useState([]);

    useEffect(() => {
        if (props?.data?.user_type && props?.data?.user_type === 'user') {
            axiosApi.get(`${config.apiUrl}/misc/player-teams/${props.data.id}`)
                .then((response) => {
                    if (response?.data?.data && response?.data?.data.length > 0) {
                        setLeagueInfo(response?.data?.data);
                    }
                })
                .catch((err) => {
                    setLeagueInfo([]);
                });
        }
    }, []);
    switch (data.shirt_size) {
        case 'S':
            shirtSize = 'Small';
            break;
        case 'M':
            shirtSize = 'Medium';
            break;
        case 'L':
            shirtSize = 'Large';
            break;
        case 'XL':
            shirtSize = 'Extra Large'
            break;
        case 'XXL':
            shirtSize = 'Largest'
            break;
        default:
            shirtSize = 'Extra Large';
    }

    const changeAccountStatus = () => {
        setOpenWarningPopup(true);
        setPopupContent({
            header: "Account Status",
            description: `Are you sure you want to change the account status? `,
            icon: faExclamationCircle,
            action: () => {
                setData((previousData) => ({
                    ...previousData,
                    'account_locked': !previousData.account_locked,
                }))
                setCheckbox(o => !o);
                setAccountStatus(true);
                setOpenWarningPopup(false);
            }
        })
    }

    useEffect(() => {
        if (accountStatus) {
            setAccountStatus(false);
            axiosApi.put(`${config.apiUrl}/users/user/${data.id}`, data)
                .then((res) => {
                    setOpenWarningPopup(false);
                    if (props.reloadListing) {
                        props.reloadListing();
                    }

                })
        }
        //eslint-disable-next-line
    }, [accountStatus])

    return <>
        <div className="modal-content" style={{ overflowY: `scroll` }}>
            <SimpleBarReact className={'custom-select'} style={{
                maxHeight: 400,
            }}>
                <ViewUserDetails
                    changeAccountStatus={changeAccountStatus}
                    data={data}
                    leagueInfo={leagueInfo}
                    shirtSize={shirtSize}
                    openResetPasswordPopUp={props.resetPassword}
                    checkbox={checkbox} />
            </SimpleBarReact>

        </div>
        <WarningDialogue
            isOpen={openWarningPopup}
            header={popupContent.header}
            description={popupContent.description}
            icon={popupContent.icon}
            action={popupContent.action}
            onClose={() => setOpenWarningPopup(false)}
        />
    </>
}